var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoMentorFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No Mentor Found"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.8271 49.0971L29.3264 45.5964",
    stroke: "#292D32",
    strokeWidth: 1.75035,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.8271 45.5964L29.3264 49.0971",
    stroke: "#292D32",
    strokeWidth: 1.75035,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.6289 25.9022C21.4169 25.881 21.1624 25.881 20.9292 25.9022C15.8833 25.7326 11.8762 21.5983 11.8762 16.51C11.8762 11.3156 16.0741 7.09656 21.2897 7.09656C26.484 7.09656 30.7031 11.3156 30.7031 16.51C30.6819 21.5983 26.6748 25.7326 21.6289 25.9022Z",
    stroke: "#292D32",
    strokeWidth: 2.62553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M37 11.3364C41.1131 11.3364 44.4205 14.665 44.4205 18.7569C44.4205 22.764 41.2403 26.029 37.2756 26.1774C37.106 26.1562 36.9152 26.1562 36.7244 26.1774",
    stroke: "#292D32",
    strokeWidth: 2.62553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.951 48.8519C20.0918 49.578 14.785 48.6841 11.0277 46.1702C5.897 42.7568 5.897 37.1596 11.0277 33.725C16.8793 29.8451 26.4412 29.8451 32.2504 33.725C35.984 36.2089 37.0007 39.8492 35.3004 42.9711",
    stroke: "#292D32",
    strokeWidth: 2.62553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M41.0916 45.2588C42.6181 44.9408 44.0597 44.3259 45.247 43.4143C48.5544 40.9337 48.5544 36.8418 45.247 34.3613C44.0809 33.4708 42.6605 32.8772 41.1552 32.538",
    stroke: "#292D32",
    strokeWidth: 2.62553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMentorFound);
export default __webpack_public_path__ + "static/media/no-mentorFound.0fcb84a690f93a7e8cac1885cb1d13fa.svg";
export { ForwardRef as ReactComponent };